import "./App.css";
import React from 'react';
import { useEffect, useState, useRef } from "react";
import ChatHeader from "./components/ChatHeader";
import ChatMessage from "./components/ChatMessage";
import LoadingIndicator from "./components/LoadingIndicator";
import StarRating from "./components/StarRating";
import ChatInput from "./components/ChatInput";
import WelcomeMessage from "./components/WelcomeMessage";

const domainAPI = process.env.REACT_APP_DOMAIN || "http://localhost:8000";
const InforLink = process.env.REACT_APP_INFO_LINK;

function App() {
    const [userInput, setUserInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [chatStatus, setChatStatus] = useState(false);
    const [currentMessageId, setCurrentMessageId] = useState("");
    const [tempRespon, setTempRespon] = useState("");
    // const [openStar, setOpenStar] = useState({
    //     status: false,
    //     messages: "Đánh giá chât lượng cuộc trò chuyện!",
    //     starSuccess: false,
    // });
    const [userNote, setUserNote] = useState("");
    const [messages, setMessages] = useState([]);
    const [content, setContent] = useState([]);
    const bottomRef = useRef(null);
    const [chatType, setChatType] = useState("spa");
    const [conversationId, setConversationId] = useState(null);
    const [socket, setSocket] = useState(null);
    // Thêm state để lưu timestamp polling webhook cuối cùng
    const [lastPollingTime, setLastPollingTime] = useState(Date.now());
    // Thêm state để theo dõi trạng thái tiếp quản
    const [agentTakeover, setAgentTakeover] = useState(false);
    // Thêm state để theo dõi chế độ hội thoại
    const [conversationMode, setConversationMode] = useState("ai");
    // Thêm state cho thông báo nhân viên online
    const [showAgentNotification, setShowAgentNotification] = useState(false);
    // get parameter from url
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const chatType = urlParams.get("chatType") || process.env.REACT_APP_CHAT_TYPE || 'spa';
        setChatType(chatType);
    }, []);
    // Thêm useEffect để polling webhook định kỳ
    useEffect(() => {
        // Chỉ poll khi conversation đã được tạo
        if (messages.length > 0) {
            const pollingInterval = setInterval(() => {
                checkForNewMessages();
            }, 3000); // Poll mỗi 3 giây

            return () => clearInterval(pollingInterval);
        }
    }, [messages.length, loading]); // Chỉ chạy lại khi số lượng tin nhắn thay đổi hoặc trạng thái loading thay đổi
    // Hàm để kiểm tra tin nhắn mới từ webhook
    const checkForNewMessages = () => {
        // Nếu đã dùng WebSocket, không cần gọi API nữa
        if (socket && socket.readyState === WebSocket.OPEN) {
            console.log("Using WebSocket instead of polling");
            return;
        }
        const parsedURL = new URL(domainAPI);
        const isNoSocket = parsedURL.port === "8000" || parsedURL.hostname === "admin.chatbot.chanh.in" || parsedURL.host === "admin.chatbot.chanh.in";

        if (isNoSocket) {
            return;
        }


        fetch(`${domainAPI}/chatwoot-webhook`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Cập nhật chế độ hội thoại nếu có
                if (data.conversation_mode) {
                    setConversationMode(data.conversation_mode);
                    
                    // Hiển thị/ẩn thông báo nhân viên dựa vào conversation_mode
                    if (data.conversation_mode === "human") {
                        setAgentTakeover(true);
                        setShowAgentNotification(true);
                    } else {
                        setAgentTakeover(false);
                        setShowAgentNotification(false);
                    }
                }

                if (data.status === "success" && data.content) {
                    // Kiểm tra tin nhắn từ nhân viên
                    const isStaffMessage =
                        data.message_type === "outgoing" &&
                        data.conversation_mode === "human";
                    
                    // Kiểm tra tin nhắn từ AI
                    const isAIMessage =
                        data.message_type === "outgoing" &&
                        data.conversation_mode === "ai";

                    // Kiểm tra xem tin nhắn đã tồn tại trong messages chưa
                    const isDuplicate = messages.some(
                        (msg) => msg.msg === data.content && !msg.fromUser
                    );

                    // Hiển thị tin nhắn từ nhân viên HOẶC AI
                    if (!isDuplicate && (isStaffMessage || isAIMessage)) {
                        // Force re-render để hiển thị tin nhắn mới
                        setTempRespon(data.content);
                        setTimeout(() => setTempRespon(""), 100);

                        // Thêm vào content giống như cách xử lý /chat
                        setContent((prevContent) => [
                            ...prevContent,
                            { msg: data.content, fromUser: "Bot" },
                        ]);

                        // Thêm tin nhắn mới vào danh sách tin nhắn
                        setMessages((prev) => [
                            ...prev,
                            { msg: data.content, fromUser: false },
                        ]);

                        executeScroll();
                    }
                }
                setLastPollingTime(Date.now());
            })
            .catch((error) => {
                console.error("Error checking for new messages:", error);
            });
    };

    const executeScroll = () => {
        setTimeout(() => {
            bottomRef.current.scrollIntoView({ behavior: "smooth" });
        }, 100);
    };

    // Add toggleChatBot function definition that was missing
    const toggleChatBot = () => {
        setChatStatus(!chatStatus);
    };

    const themes = {
        primaryColor: "#1da64c",
        secondryColor: "#475569",
        primaryFontColor: "white",
        secondryFontColor: "#2C3333",
        logoColor: "#E7F6F2",
    };

    const sendMessage = async () => {
        if (userInput !== "" && (!loading || conversationMode === "human")) {
            // Luôn luôn thêm tin nhắn của người dùng vào UI ngay lập tức
            const newUserMessage = { msg: userInput, fromUser: true };
            const newContent = { msg: userInput, fromUser: "Customer" };
            
            setContent(prevContent => [...prevContent, newContent]);
            setMessages(prevMessages => [...prevMessages, newUserMessage]);
            
            // Lưu userInput trước khi set thành rỗng
            const currentInput = userInput;
            setUserInput("");

            // Trong chế độ human, không set loading để giữ style input
            if (conversationMode === "human" || agentTakeover) {
                // Gửi tin nhắn tới API và reset loading ngay lập tức
                fetch(`${domainAPI}/chat`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_input: currentInput,
                        chat_history: messages.map((item) => ({
                            role: item.fromUser ? "user" : "assistant",
                            content: item.msg.replace("\n", ""),
                        })),
                        chatType: chatType,
                        conversation_id: conversationId,
                        conversation_mode: "human",
                    }),
                });

                executeScroll();
                return;
            }

            // Set loading cho chế độ AI
            setLoading(true);

            const startTime = new Date().getTime();

            let history = [];
            if (messages.length > 0) {
                history = messages
                    .map((item, index) => {
                        if (index === messages.length - 1) return null;
                        return {
                            role: item.fromUser ? "user" : "assistant",
                            content: item.msg.replace("\n", ""),
                        };
                    })
                    .filter((item) => item !== null);
            }

            // Gửi tin nhắn đến backend với thông tin về chế độ hội thoại
            fetch(`${domainAPI}/chat`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_input: currentInput,
                    chat_history: history,
                    chatType: chatType,
                    conversation_id: conversationId,
                    conversation_mode: conversationMode,
                }),
            })
                .then((response) => {
                    // Kiểm tra xem phản hồi có thành công không
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }

                    // Lấy conversation_id từ headers nếu có
                    const conversation_id = response.headers.get("X-Conversation-ID");
                    if (conversation_id) {
                        setConversationId(conversation_id);
                    }

                    // Kiểm tra chế độ nhân viên từ header
                    const humanMode = response.headers.get("X-Human-Mode");
                    if (humanMode === "true") {
                        console.log("Xác nhận chế độ nhân viên từ server");
                        setAgentTakeover(true);
                        setLoading(false);
                        executeScroll();
                        return null;
                    }

                    return response.body;
                })
                .then((stream) => {
                    if (!stream) return;

                    let resultsTxt = "";
                    const reader = stream.getReader();
                    executeScroll();
                    
                    reader.read().then(function processResult(result) {
                        if (result.done) {
                            // Khi stream kết thúc, xử lý trực tiếp thay vì dùng setResponseData
                            const finalContent = { msg: resultsTxt, fromUser: "Bot" };
                            const finalMessage = { msg: resultsTxt, fromUser: false };
                            
                            setContent(prevContent => [...prevContent, finalContent]);
                            setMessages(prevMessages => [...prevMessages, finalMessage]);
                            
                            setTempRespon("");
                            setLoading(false);
                            executeScroll();
                            return;
                        }
                        
                        // Xử lý dữ liệu stream
                        resultsTxt += new TextDecoder("utf-8").decode(result.value);
                        resultsTxt.replace(/\n/g, "<br/>");
                        setTempRespon(resultsTxt);
                        
                        return reader.read().then(processResult);
                    });
                })
                .catch((error) => {
                    console.error("Chat API error:", error);
                    setLoading(false);
                    // Hiển thị lỗi cho người dùng nếu cần
                    const errorMessage = { msg: "Xin lỗi, đã có lỗi xảy ra. Vui lòng thử lại.", fromUser: false };
                    setMessages(prevMessages => [...prevMessages, errorMessage]);
                    executeScroll();
                });
        }
    };

    // Add handleKeyDown function definition that was missing
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault(); // prevents the default behavior of adding a new line
            sendMessage();
        }
    };

    // Add handleLike function definition that was missing
    const handleLike = async (action) => {
        let data = { ...action, currentMessageId: currentMessageId };
        if (
            messages[data.messageKey].like === true ||
            messages[data.messageKey].dislike === true ||
            messages[data.messageKey].satisfied === true ||
            messages[data.messageKey].unsatisfied === true
        ) {
            return true;
        }
        // Additional like handling logic can be added here
    };

    // Thêm hàm để kiểm tra trạng thái tiếp quản định kỳ
    useEffect(() => {
        if (conversationId) {
            const statusCheckInterval = setInterval(() => {
                fetch(`${domainAPI}/chat-status/${conversationId}`)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.agent_takeover !== agentTakeover) {
                            setAgentTakeover(data.agent_takeover);
                            console.log(
                                `Trạng thái tiếp quản thay đổi: ${data.agent_takeover
                                    ? "Nhân viên tiếp quản"
                                    : "Chatbot hoạt động"
                                }`
                            );
                        }
                    })
                    .catch((error) => console.error("Lỗi kiểm tra trạng thái:", error));
            }, 100);

            return () => clearInterval(statusCheckInterval);
        }
    }, [conversationId, agentTakeover]);

    // Cập nhật xử lý tin nhắn WebSocket để hỗ trợ mode switch đặc biệt
    useEffect(() => {
        if (conversationId) {
            // Đóng socket cũ nếu có
            if (socket) {
                socket.close();
            }

            const wsUrl = `${domainAPI.replace("http", "ws")}/ws/${conversationId}`;
            console.log(`Connecting to WebSocket at ${wsUrl}`);

            const newSocket = new WebSocket(wsUrl);
            let streamingMessage = ""; // Khởi tạo biến lưu tin nhắn đang stream

            newSocket.onopen = () => {
                console.log("WebSocket connection established");
            };

            newSocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                console.log("WebSocket message received:", data);

                // Cập nhật trạng thái tiếp quản từ server
                if (data.agent_takeover !== undefined) {
                    setAgentTakeover(data.agent_takeover);
                    console.log(
                        `Cập nhật trạng thái tiếp quản từ WebSocket: ${data.agent_takeover ? "Nhân viên tiếp quản" : "Chatbot hoạt động"
                        }`
                    );
                }

                // Cập nhật chế độ hội thoại nếu có
                if (data.conversation_mode) {
                    const oldMode = conversationMode;
                    setConversationMode(data.conversation_mode);

                    // Hiển thị/ẩn thông báo nhân viên dựa vào conversation_mode
                    if (data.conversation_mode === "human") {
                        setShowAgentNotification(true);
                    } else {
                        setShowAgentNotification(false);
                    }

                    // Thêm thông báo khi chuyển chế độ
                    if (oldMode !== data.conversation_mode) {
                        if (data.conversation_mode === "ai" && oldMode === "human") {
                            // Không cần thêm thông báo vì đã xử lý ở trên (nếu là từ lệnh @chatbot)
                        } else if (data.conversation_mode === "human" && oldMode === "ai") {
                            setMessages((prev) => [
                                ...prev,
                                {
                                    msg: "Nhân viên hỗ trợ đã tham gia cuộc trò chuyện",
                                    fromUser: false,
                                    isSystemMessage: true,
                                },
                            ]);
                            executeScroll();
                        }
                    }

                    // Đặt trạng thái tiếp quản nếu ở chế độ người thật
                    if (data.conversation_mode === "human") {
                        setAgentTakeover(true);
                    }
                }

                // Xử lý trường hợp streaming (tin nhắn đang được gửi từng phần)
                if (data.status === "streaming" && data.streaming === true) {
                    console.log("Received streaming chunk:", data.content);

                    // Thêm phần nhận được vào tin nhắn đang stream
                    streamingMessage += data.content;

                    // Hiển thị phần đã nhận trong UI với hiệu ứng typing
                    setTempRespon(streamingMessage);
                    executeScroll();
                    return; // Không thêm vào messages state chưa vì đang stream
                }

                if (data.status === "success" && data.content) {
                    const isStaffMessage =
                        data.message_type === "outgoing" &&
                        data.conversation_mode === "human";

                    // Nếu đây là kết thúc của một tin nhắn stream
                    if (data.streaming === false && isStaffMessage) {
                        console.log("Stream complete, final message:", data.content);
                        streamingMessage = ""; // Reset biến stream
                        setTempRespon(""); // Xóa tempRespon để không hiển thị nữa

                        // Thêm tin nhắn hoàn chỉnh vào danh sách
                        setContent((prevContent) => [
                            ...prevContent,
                            { msg: data.content, fromUser: "Bot" },
                        ]);

                        setMessages((prev) => [
                            ...prev,
                            { msg: data.content, fromUser: false },
                        ]);
                        executeScroll();
                        return;
                    }

                    // Cập nhật trạng thái tiếp quản nếu nhận được tin nhắn từ nhân viên
                    if (isStaffMessage) {
                        setAgentTakeover(true);
                        console.log("Nhân viên đã tiếp quản cuộc hội thoại (WebSocket)");

                        // Kiểm tra xem tin nhắn đã tồn tại trong messages chưa
                        const isDuplicate = messages.some(
                            (msg) => msg.msg === data.content && !msg.fromUser
                        );

                        // Chỉ thêm nếu không phải tin nhắn trùng lặp
                        if (!isDuplicate) {
                            setContent((prevContent) => [
                                ...prevContent,
                                { msg: data.content, fromUser: "Bot" },
                            ]);

                            setMessages((prev) => [
                                ...prev,
                                { msg: data.content, fromUser: false },
                            ]);
                            executeScroll();
                        }
                    }
                }
            };

            newSocket.onclose = () => {
                console.log("WebSocket connection closed");
            };

            newSocket.onerror = (error) => {
                console.error("WebSocket error:", error);
            };

            setSocket(newSocket);

            // Cleanup function để đóng kết nối khi component unmount
            return () => {
                newSocket.close();
            };
        }
    }, [conversationId]);

    // Cập nhật state conversationId khi nhận từ API
    useEffect(() => {
        if (messages.length > 0 && conversationId) {
            // Không cần gán lại conversationId vì đã có
            console.log("Conversation ID updated:", conversationId);

            // Debug để xác định vấn đề với conversation
            console.log("Current chat state:", {
                conversationMode,
                agentTakeover,
                messagesCount: messages.length,
                conversationId,
            });
        }
    }, [conversationId]);

    // Bỏ hàm renderConversationModeIndicator không cần thiết nữa
    // Sửa hàm renderStatusMessage để không hiển thị thông báo
    const renderStatusMessage = () => {
        // Trả về null để không hiển thị gì cả
        return null;
    };

    return (
        <div className="wrap-chat">
            <a
                className={`wrap-chat-btn ` + (chatStatus ? "hide" : "init")}
                onClick={toggleChatBot}
            >
                <svg
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
            </a>
            <div className={`chatbot ` + (chatStatus ? "active" : "init")}>
                <ChatHeader
                    themes={themes}
                    toggleChatBot={toggleChatBot}
                    chatType={chatType}
                    InforLink={InforLink}
                />
                {/* Thông báo nhân viên online */}
                {showAgentNotification && (
                    <div className="agent-notification">
                        <div className="agent-notification-content">
                            <div className="agent-status-indicator"></div>
                            <span>Nhân viên tư vấn đang online</span>
                        </div>
                    </div>
                )}

                <div className="chatbot-content">
                    <div className="max-w-2xl mx-auto space-y-12 grid grid-cols-1 overflow-y-auto scroll-smooth scrollbar-hide overflow-x-hidden">
                        {renderStatusMessage()}
                        <ul>
                            <WelcomeMessage themes={themes} chatType={chatType} />
                            {messages &&
                                messages.map((message, idx) => (
                                    <ChatMessage
                                        key={idx}
                                        message={message}
                                        idx={idx}
                                        themes={themes}
                                        handleLike={handleLike}
                                        messages={messages}
                                    />
                                ))}
                        </ul>
                        {/* Tắt hiển thị loading indicator khi ở chế độ nhân viên */}
                        {loading && conversationMode !== "human" && (
                            <LoadingIndicator
                                loading={loading}
                                tempRespon={tempRespon}
                                themes={themes}
                            />
                        )}
                        {/* <StarRating
                            openStar={openStar}
                            messages={messages}
                            handleLike={handleLike}
                            userNote={userNote}
                            setUserNote={setUserNote}
                            loading={loading}
                        /> */}
                        <div ref={bottomRef} />
                    </div>
                </div>
                <ChatInput
                    userInput={userInput}
                    setUserInput={setUserInput}
                    handleKeyDown={handleKeyDown}
                    loading={loading} // Truyền loading thông thường, không thêm điều kiện
                    sendMessage={sendMessage}
                    // setOpenStar={setOpenStar}
                    // openStar={openStar}
                />
            </div>
        </div>
    );
}

export default App;
